import { type ComponentType, createContext, type ReactNode, useContext } from 'react';

export interface LinkProps {
  to: string;
  className?: string;
  children: ReactNode;
  'aria-current'?: 'page';
  title?: string;
}

/** The UI kit does not know the router; the app provides its Link. */
const LinkContext = createContext<ComponentType<LinkProps>>(({ to, children, ...rest }) => (
  <a href={to} {...rest}>
    {children}
  </a>
));

export const LinkProvider = LinkContext.Provider;
export const useLink = () => useContext(LinkContext);
